import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const ModuleFilterMenu = ({
  open,
  onToggle,
  onClose,
  label = "Filter",
  icon = "ph:funnel",
  eyebrow = "Refine results",
  title = "Filters",
  count = 0,
  columns = 3,
  size = "wide",
  ariaLabel,
  children,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) onClose();
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  return (
    <div className="module-filter-menu" ref={ref}>
      <button className="ui-button" type="button" aria-expanded={open} onClick={onToggle}>
        <Icon icon={icon} height={14} />
        {label}
        {count > 0 && <em className="module-filter-menu__count">{count}</em>}
      </button>
      {open && (
        <div
          className={`module-filter-panel module-filter-panel--${size}`}
          role="dialog"
          aria-label={ariaLabel || title}
        >
          <header>
            <p>{eyebrow}</p>
            <h3>{title}</h3>
          </header>
          <div className="module-filter-panel__grid" style={{ "--filter-cols": columns }}>
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default ModuleFilterMenu;
